<script lang="ts">
  /**
   * /about — 1:1 port of index.html lines 1054-1099 (about-page).
   * Uses legacy classes: .page.active, .about-container, .story-section,
   * .section-content, .highlight-subject, .feedback-section,
   * .section-title, .feedback-text, .feedback-form-container,
   * .feedback-iframe, .about-footer, .footer-container, .footer-copyright.
   */
</script>

<svelte:head>
  <title>Біз туралы — Zetix</title>
  <meta name="description" content="Zetix — оқушыларға уақыт үнемдеуге және ҰБТ-ға дайындалуға қажетті мәліметтерді оқулықтардан жылдам табуға көмектесетін жоба." />
</svelte:head>

<div class="page active" id="about-page">
  <div class="about-container">
    <section class="story-section">
      <div class="section-content">
        <div class="story-text">
          <p>
            <span class="highlight-subject">Zetix</span> — оқушыларға уақыт үнемдеуге және ҰБТ-ға дайындалуға қажетті мәліметтер мен күнделікті сабақта қолданылатын ұғымдарды оқулықтардан жылдам табуға көмектесетін жоба. Біздің мақсат — білім алу жолын жеңілдетіп, ізденуді нәтижелі ету.
          </p>
          <p>
            Жоба Қазақстандағы білім сапасын арттыруға және заманауи технологияларды тиімді пайдалануға деген ұмтылыстан туған. Автор әрі негізгі әзірлеуші — <span class="highlight-subject">Камал Жансерік</span>. Zetix әр оқушы үшін сенімді серік болып, білім жолында бағыт-бағдар беретін құралға айналуды мақсат етеді.
          </p>
        </div>
      </div>
    </section>

    <section class="feedback-section">
      <div class="section-content">
        <h2 class="section-title">Кері байланыс</h2>
        <div class="feedback-text">
          <p>Платформадан қате байқасаңыз немесе ұсынысыңыз болса, бізге хабарласыңыз. Сіздің пікіріңіз біз үшін өте құнды.</p>
        </div>
        <div class="feedback-form-container">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSd1UcO8TQWCiDG2K9kuo8XaRmgDA2XPurweDkxh_J3p4e3tfg/viewform?usp=pp_url&entry.1000000=ZetixFeedback"
            width="100%"
            height="500"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            title="Кері байланыс формасы"
            class="feedback-iframe"
          >
            Жүктелуде…
          </iframe>
        </div>
      </div>
    </section>

    <footer class="about-footer">
      <div class="footer-container" style="justify-content:center;">
        <div class="footer-copyright">
          <p style="margin:0;">© 2026 Zetix. Барлық құқықтар қорғалған.</p>
        </div>
      </div>
    </footer>
  </div>
</div>
